import * as Tooltip from "@radix-ui/react-tooltip";

export interface DocumentTooltipProps {
  children: React.ReactNode;
  content: string;
}

export default function DocumentTooltip({
  children,
  content,
}: DocumentTooltipProps) {
  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          {children}
        </Tooltip.Trigger>

        <Tooltip.Portal>
          <Tooltip.Content
            side="bottom"
            sideOffset={1}
            className="
              z-[9999]
              flex items-start
              gap-2
              w-[266px]
              max-w-[384px]
              px-3 py-[6px]
              rounded-md
              bg-gray-700
              text-white text-xs font-normal leading-4
            "
          >
            {content}

            <Tooltip.Arrow className="fill-gray-700" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
